import CampaignModel from 'cio/models/campaign';
import NewsletterModel from 'cio/models/newsletter';
import TransactionalMessageModel from 'cio/models/transactional-message';

export function shortTypeName(item: CampaignModel | NewsletterModel | TransactionalMessageModel) {
  if (item instanceof CampaignModel) {
    return item.isApiTriggered ? 'broadcast' : 'campaign';
  }

  if (item instanceof NewsletterModel) {
    return 'newsletter';
  }

  if (item instanceof TransactionalMessageModel) {
    return 'message';
  }

  return '';
}
